import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from './UI/Modal';
import { UberDich } from './Register';
import { checkAuthState, updateUserProfile } from '../store/authSlice';
import { trackProfileComplete } from '../util/tracking';
import classes from './SignIn.module.css';

const isMissing = (value) => !value || String(value).trim() === '';

const ProfileCompletionModal = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, status, user, profileUpdateStatus } = useSelector((state) => state.auth);
  const [error, setError] = useState('');

  const shouldCompleteProfile =
    status === 'succeeded' &&
    isAuthenticated &&
    profileUpdateStatus !== 'loading' &&
    (isMissing(user?.firstName) || isMissing(user?.lastName) || isMissing(user?.birthDate));

  const handleSubmit = async ({ name, surname, birthday }) => {
    setError('');

    const result = await dispatch(updateUserProfile({
      firstName: name,
      lastName: surname,
      birthDate: birthday,
    }));

    if (updateUserProfile.rejected.match(result)) {
      setError(result.payload || 'Profil konnte nicht gespeichert werden.');
      return;
    }

    await dispatch(checkAuthState());
    trackProfileComplete({
      source: 'profile_completion_modal',
    });
  };

  return (
    <Modal open={shouldCompleteProfile}>
      <div className={classes.modalContainer}>
        <h1 className='titleSemibold'>Über dich</h1>
        {error && (
          <div className={classes.error}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M1.02734 1.40723L10.9725 11.3524" stroke="#CB1541" strokeWidth="1.5" strokeMiterlimit="10"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M4.9452 6.37988L0.5 1.93469L1.5548 0.879883L6 5.32508L10.4452 0.879883L11.5 1.93469L7.0548 6.37988L11.5 10.8251L10.4452 11.8799L6 7.43469L1.5548 11.8799L0.5 10.8251L4.9452 6.37988Z" fill="#CB1541"/>
            </svg>
            <span>{error}</span>
          </div>
        )}
        <UberDich
          onUberDichSubmit={handleSubmit}
          isCreating={profileUpdateStatus === 'loading'}
          submitLabel="Speichern"
          loadingLabel="Speichern..."
        />
      </div>
    </Modal>
  );
};

export default ProfileCompletionModal;
